<template>
	<div class="CaretDown svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1698636422818" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4185" :width="size" :height="size">
			<path d="M64 320l448 448 448-448z" fill="#262626" p-id="4186"></path>
		</svg>
	</div>
</template>
<script setup name="CaretDown">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 16
		}
	})
</script>
<style scoped lang="less">
	.CaretDown,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
